import { Row } from '@simplywallst/ui-core';
import Media from 'react-media';
import { useTheme } from '@simplywallst/ui-core';
import { LogoBlack, LogoWhite, LogoContainer } from './styled';
import loadable from '@loadable/component';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { QUERYSTRING_SALES_SITE } from '@/constants/routes';

const Links = loadable(() => import('./Links'), {
  resolveComponent: (component) => component.Links,
});

const MobileNav = loadable(() => import('./MobileNav'), {
  resolveComponent: (component) => component.MobileNav,
});

interface Props {
  isWhite?: boolean;
}

export const Navigation = ({ isWhite }: Props) => {
  const theme = useTheme();
  const { isMobile, isTablet } = useUserAgent();
  return (
    <Row>
      <LogoContainer col={6} colMd={2} colLg={2}>
        <a href={QUERYSTRING_SALES_SITE}>
          {isWhite ? <LogoWhite /> : <LogoBlack />}
        </a>
      </LogoContainer>
      <Media
        query={{ maxWidth: theme.mdMinRaw }}
        defaultMatches={isMobile || isTablet}
      >
        {(match) => {
          return match ? (
            <MobileNav isWhite={isWhite} />
          ) : (
            <Links isWhite={isWhite} />
          );
        }}
      </Media>
    </Row>
  );
};
